<script setup>
import '@/assets/cloudCounter/css/style.css';
import { computed, onMounted, ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import Process from '@/components/cloudCounter/Process.vue';
import { useRouter } from 'vue-router';
import { postCheckReserveDatetimePeriodApply } from '@/apis/CloudECounterReserve';
import routeName from '@/router/constant';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import { postCecRecord, postCancelTransaction } from '@/apis/record';
// import { cancelTransaction } from '@/apis/system';
import { useStore } from 'vuex';
import { convertCaseBoxList } from '@/views/cloudECounter/reserve/record/caseBoxUtils';
import applicantField from '@/views/cloudECounter/reserve/record/applicantField';
import Loading from '@/components/Loading.vue';

const router = useRouter();
const store = useStore();

const goNextPage = () => {
    if (!canVideo.value) {
        return;
    }
    isLoading.value = true;
    postCheckReserveDatetimePeriodApply().then(res => {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_VIDEO });
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};
const isLoading = ref(true);
const canCancel = ref(false);
const canVideo = ref(false);
const regiNo = computed(() => store.state.permissions.userInfo?.reserveVideo?.regiNo);
const endoresmentContent = ref({
    boxList: [{
        title: '本次變更批註寄送方式',
        list: [{
            key: '',
            value: '',
        }],
    }],
});

// #region  新要保人姓名
const newApplicantName = ref({
    boxList: [{
        title: '',
        list: [],
    }],
});

// #endregion

// #region 新被保險人姓名
const newAssuredName = ref({
    boxList: [{
        title: '',
        list: [],
    }],
});
const record = ref({
    boxList: [{ list: [] }],
});
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {
    isLoading.value = true;
    postCancelTransaction(regiNo.value).then(res => {
        openPopup('已完成取消預約申請');
        canCancel.value = false;
        canVideo.value = false;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};

onMounted(() => {
    postCecRecord(regiNo.value).then(res => {
        const a = res.data?.applicantInsuredNameChange?.after;
        record.value.boxList = convertCaseBoxList(res.data, applicantField.record);
        newApplicantName.value = {
            boxList: [{
                title: a.name,
                list: a.policyVoList?.map(p => {
                    return {
                        key: p.fullPolicyNo,
                        value: p.item + p.itemName,
                    };
                }),
            }],
        };
        newAssuredName.value = {
            boxList: [{
                title: a.insuredName,
                list: a.insuredVoList?.map(p => {
                    return {
                        key: p.fullPolicyNo,
                        value: p.item + p.itemName,
                    };
                }),
            }],
        };
        canCancel.value = res.data.canCancel;
        canVideo.value = res.data.canVideo;
        if (res.data?.applicantInsuredNameChange?.insuredMobile) {
            newAssuredName.value.boxList.push({
                title: '被保險人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data?.applicantInsuredNameChange?.insuredMobile.mobile,
                }],
            });
        }
        if (res.data?.applicantInsuredNameChange?.insMobile) {
            newApplicantName.value.boxList.push({
                title: '要保人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data?.applicantInsuredNameChange?.insMobile.mobile,
                }],
            });
        }
        endoresmentContent.value.boxList[0].list[0].value = res.data?.endorsementDesc;
    }).catch(ex => {
        console.log(ex);
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
});
</script>

<template>
    <div>
        <!-- 要保人/受益人姓名變更 -->
        <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} } }">

            <div class="pt-2 pb-6">
                <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
            </div>

            <div class="pb-6">
                <h2 class="pb-3 text-2xl font-bold">
                    申請紀錄
                </h2>
                <CaseBox :caseBox="record" />
            </div>

            <h2 class="pb-3 text-2xl font-bold">
                申請明細
            </h2>

            <div v-if="newApplicantName.boxList[0]?.title" class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    要保人新姓名
                </h3>
                <p v-if="newApplicantName.boxList[0]?.list?.length > 0" class="pb-4 text-sm">
                    同時辦理以下保單號碼之要保人姓名變更
                </p>
                <CaseBox :caseBox="newApplicantName" />
            </div>

            <div v-if="newAssuredName.boxList[0]?.title" class="pb-2">
                <h3 class="pb-4 text-xl font-bold">
                    被保險人新姓名
                </h3>
                <p v-if="newAssuredName.boxList[0]?.list?.length > 0" class="pb-4 text-sm">
                    同時辦理以下保單號碼之被保險人姓名變更
                </p>
                <CaseBox :caseBox="newAssuredName" />
            </div>

            <div class="pb-2">
                <CaseBox :caseBox="endoresmentContent" />
            </div>

            <div v-if="canCancel" class="text-center">
                <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true; }">取消預約申請
                </button>
            </div>

            <template v-slot:bottom>
                <button
                    class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :class="canVideo ? '' : 'bg-gray-300'" @click="goNextPage">開始視訊
                </button>
            </template>
            <Loading :is-loading="isLoading" />
        </Layout>

        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？"
            type="confirm" :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />
    </div>
</template>

<style scoped></style>
